/**
 * cart-drawer-fix.js (v6.3)
 * カートドロワー × GPO（Globo Product Options）の表示同期。
 */
(function () {
  'use strict';

  var QUIET_MS = 700;          // 最後のカート通信からこの時間だけ静かなら「落ち着いた」とみなす
  var MAX_WAIT_MS = 6000;      // 通信が途切れなくても、この時間で一度は照合する
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var SOURCE = 'a97-cart-drawer-fix';
  var CHILD_CLASS = 'a97-gpo-child';
  var CHILD_EDITABLE_CLASS = 'a97-gpo-child--editable';   // 商品ページで個数を選べた子（_gpo_quantity_mix 持ち）
  var NOTE_CLASS = 'a97-gpo-child__note';
  var NOTE_TEXT = 'セット商品（本体の数量に連動します）';
  var NOTE_TEXT_EDITABLE = 'セット商品（本体1点につき {n} 個）';
  var HINT_CLASS = 'a97-gpo-child__hint';
  var HINT_MIN = '本体1点につき1個以上のご注文が必要です';
  var CLEAR_CLASS = 'a97-cart-clear';

  // ⑫ 在庫不足の案内。GPO の文言は {{product_title}} {{inventory_quantity}} を GPO が置換する
  var GPO_MSG_INVENTORY = '「{{product_title}}」は在庫が足りないため、カートに追加できませんでした。\n' +
    'ご注文いただける数量は{{inventory_quantity}}点までです（カートに入っている数量を含みます）。';
  var GPO_MSG_SOLDOUT = '在庫切れの商品が選ばれているため、カートに追加できませんでした。\n' +
    '在庫切れの商品の選択を外してから、もう一度お試しください。';
  var STOCK_MSG_SHORT = '「{title}」は在庫が足りないため、カートに追加できませんでした。\n' +
    'ご注文いただける数量は{n}点までです。';
  var STOCK_MSG_SHORT_INCART = '「{title}」は在庫が足りないため、カートに追加できませんでした。\n' +
    'ご注文いただける数量は{n}点までです（カートに入っている{m}点を含みます）。';
  var STOCK_MSG_NONE = '「{title}」は在庫切れのため、カートに追加できませんでした。';
  var STOCK_MSG_FALLBACK = '在庫が足りない商品があるため、カートに追加できませんでした。';

  var themeEvents = null;      // import('@theme/events') の結果
  var sectionRenderer = null;  // import('@theme/section-renderer') の結果

  /* ------------------------------------------------------------------ *
   * 小物
   * ------------------------------------------------------------------ */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function warn() { if (window.console && console.warn) console.warn.apply(console, arguments); }

  function drawer() {
    var d = $('cart-drawer-component');
    if (d && !d.__a97gated) gateDrawer(d);
    return d;
  }
  function dialogOf(d) { return d ? d.querySelector('dialog') : null; }
  // 閉じるアニメーション中（dialog-closing）は open が残っているので閉じている扱いにする
  function isOpen() { var dlg = dialogOf(drawer()); return !!(dlg && dlg.open && !dlg.classList.contains('dialog-closing')); }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); });
  }

  // テーマのモジュールは importmap 経由。古いブラウザでは null のままフォールバックで動く。
  function loadThemeModules() {
    if (themeEvents !== null) return Promise.resolve();
    var p1 = (new Function('return import("@theme/events")'))().then(function (m) { themeEvents = m; }, function () { themeEvents = false; });
    var p2 = (new Function('return import("@theme/section-renderer")'))().then(function (m) { sectionRenderer = m; }, function () { sectionRenderer = false; });
    return Promise.all([p1, p2]);
  }

  /* ------------------------------------------------------------------ *
   * ⑬ ドロワーを開く判断
   *   テーマの CartAddEvent は cart:update と同じイベント名で、auto-open のドロワーは
   *   あらゆる cart:update で showDialog() する。開く経路をここ 1 か所で止める。
   * ------------------------------------------------------------------ */

  var CLOSE_HOLD_MS = 20000;   // 利用者が閉じてから、自動では開かない時間（GPO の後追い通信は約12秒後まで）
  var userClosedAt = 0;
  var inUserClick = false;     // 利用者のクリックの処理中（ドロワーの中・背景のクリックは除く）
  var ownDispatch = 0;         // こちらが cart:update を投げている最中

  function markUserClosed() {
    userClosed = true;
    userClosedAt = Date.now();
  }

  // 変えると動かなくなる: gpo-telemetry.js は GPO の読み込みを最大 8 秒待ってから送信する
  var ADD_INTENT_MS = 15000;
  var addIntentAt = 0;         // カート追加ボタンを押した時刻。これが新しい /cart/add だけドロワーを開く

  function takeAddIntent() {
    var ok = Date.now() - addIntentAt < ADD_INTENT_MS;
    addIntentAt = 0;
    return ok;
  }

  var ATC_SEL = '.gpo-clone-atc-button, .gpo-original-atc-button, .gPreorderBtn, button.add-to-cart-button, .add-to-cart-button, button[name="add"]';

  window.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var t = e.target;
    // カート追加を押したら、閉じたあとの保留を解く（ドロワーは送信開始時に開く）。ほかのクリックで取り消す
    if (t instanceof Element && t.closest(ATC_SEL)) {
      userClosedAt = 0;
      addIntentAt = Date.now();
      ensureGpoMessages();
    } else {
      addIntentAt = 0;
    }
    var dlg = dialogOf($('cart-drawer-component'));
    if (dlg && t instanceof Node && dlg.contains(t)) return;
    inUserClick = true;
    setTimeout(function () { inUserClick = false; }, 0);
  }, true);

  function mayOpen() {
    if (inUserClick) { userClosedAt = 0; return true; }
    if (Date.now() - userClosedAt < CLOSE_HOLD_MS) return false;
    return ownDispatch === 0;
  }

  function gateDrawer(d) {
    d.__a97gated = true;
    d.showDialog = function () {
      if (!mayOpen()) return;
      var C = window.customElements && customElements.get('cart-drawer-component');
      var fn = C && C.prototype.showDialog;
      if (typeof fn === 'function') return fn.apply(this, arguments);
    };
  }

  /**
   * ヘッダーに出す個数。まとめて配送の目印の商品は数えない（snippets/cart-bubble.liquid と同じ）。
   * 目印のバリエーション ID は snippets/a97-ship-choice.liquid が data-flag-variant に出す
   */
  function shownCount(cart) {
    var el = $('.a97-ship-choice[data-flag-variant]');
    var flag = el ? Number(el.getAttribute('data-flag-variant')) : 0;
    var n = cart.item_count || 0;
    if (flag) (cart.items || []).forEach(function (it) { if (Number(it.variant_id) === flag) n -= it.quantity; });
    return Math.max(0, n);
  }

  /** テーマの cart:update を投げる（バッジ更新用）。これでドロワーが開くことはない */
  function dispatchCartUpdate(cart, extra) {
    if (!(themeEvents && themeEvents.CartUpdateEvent)) return false;
    var data = { itemCount: shownCount(cart), source: SOURCE };
    if (extra) Object.keys(extra).forEach(function (k) { data[k] = extra[k]; });
    ownDispatch++;
    try { document.dispatchEvent(new themeEvents.CartUpdateEvent(cart, SOURCE, data)); }
    finally { ownDispatch--; }
    return true;
  }

  function injectStyle() {
    if (document.getElementById('a97-cart-drawer-fix-style')) return;
    var st = document.createElement('style');
    st.id = 'a97-cart-drawer-fix-style';
    st.textContent =
      '.' + CHILD_CLASS + ':not(.' + CHILD_EDITABLE_CLASS + ') cart-quantity-selector-component,' +
      '.' + CHILD_CLASS + ':not(.' + CHILD_EDITABLE_CLASS + ') .quantity-selector,' +
      '.' + CHILD_CLASS + ':not(.' + CHILD_EDITABLE_CLASS + ') .cart-items__remove{display:none !important;}' +
      '.' + CHILD_EDITABLE_CLASS + ' .cart-items__remove.gpo-hidden{display:grid !important;opacity:1 !important;visibility:visible !important;}' +
      // GPO は子行の数量欄を .gpo-hidden と td の opacity:0 で隠す。数量を変えられる子だけ戻す
      '.' + CHILD_EDITABLE_CLASS + ' .cart-items__quantity{opacity:1 !important;}' +
      '.' + CHILD_EDITABLE_CLASS + ' cart-quantity-selector-component.gpo-hidden{display:flex !important;opacity:1 !important;visibility:visible !important;}' +
      'cart-drawer-component .' + NOTE_CLASS + '{margin:4px 0 0;font-size:11px;line-height:1.5;color:#6b675f;}' +
      '.' + HINT_CLASS + '{margin:4px 0 0;font-size:11px;line-height:1.5;color:#b3261e;}' +
      // カートを空にする
      '.' + CLEAR_CLASS + '{margin:12px 0 4px;text-align:right;font-size:12px;}' +
      'cart-drawer-component .' + CLEAR_CLASS + '{padding:0 24px 8px;}' +
      '.' + CLEAR_CLASS + ' button{background:none;border:0;padding:4px 0;color:#6b675f;text-decoration:underline;cursor:pointer;font:inherit;font-size:12px;}' +
      '.' + CLEAR_CLASS + '-dialog{border:0;border-radius:8px;padding:24px;max-width:min(92vw,360px);width:100%;box-shadow:0 12px 40px rgba(0,0,0,.25);font-size:14px;line-height:1.6;color:#1a1a18;}' +
      '.' + CLEAR_CLASS + '-dialog::backdrop{background:rgba(0,0,0,.45);}' +
      '.' + CLEAR_CLASS + '-dialog h2{margin:0 0 8px;font-size:16px;font-weight:700;}' +
      '.' + CLEAR_CLASS + '-dialog p{margin:0 0 20px;}' +
      '.' + CLEAR_CLASS + '-dialog__actions{display:flex;gap:8px;justify-content:flex-end;}' +
      '.' + CLEAR_CLASS + '-dialog__actions button{font:inherit;font-size:13px;padding:9px 16px;border-radius:6px;cursor:pointer;border:1px solid #c9c6bf;background:#fff;color:#1a1a18;}' +
      '.' + CLEAR_CLASS + '-dialog__actions button[data-a97-confirm]{background:#b3261e;border-color:#b3261e;color:#fff;}' +
      // 親行の削除中（テーマの morph でクラスが落ちるので、覆いは body 直下の別要素にする）
      '.a97-cart-lock{position:fixed;inset:0;z-index:2147482000;background:rgba(255,255,255,.45);cursor:wait;}' +
      '.a97-cart-lock--in-dialog{position:absolute;}' +
      '.a97-cart-lock::before{content:"";position:absolute;left:50%;top:50%;width:28px;height:28px;margin:-14px 0 0 -14px;' +
      'border:3px solid rgba(0,0,0,.15);border-top-color:#1a1a18;border-radius:50%;animation:a97-spin .8s linear infinite;}' +
      // カート追加中: 中身を全部隠して追加中の表示だけ出す
      'body.a97-adding cart-drawer-component .cart-drawer__content > :not(.a97-cart-adding){visibility:hidden !important;}' +
      'body.a97-adding cart-drawer-component .cart-drawer__content{position:relative;min-height:240px;}' +
      '.a97-cart-adding{position:absolute;inset:0;z-index:1;display:flex;flex-direction:column;align-items:center;justify-content:center;' +
      'gap:10px;padding:24px;text-align:center;background:inherit;}' +
      '.a97-cart-adding__spinner{width:28px;height:28px;border:3px solid rgba(0,0,0,.12);border-top-color:#1a1a18;' +
      'border-radius:50%;animation:a97-spin .8s linear infinite;}' +
      '.a97-cart-adding__img{width:96px;height:96px;object-fit:contain;border-radius:6px;background:#f6f6f4;}' +
      '.a97-cart-adding__title{font-size:13px;line-height:1.4;color:#1a1a18;max-width:100%;}' +
      '.a97-cart-adding__status{font-size:12px;color:#6b675f;}' +
      '@keyframes a97-spin{to{transform:rotate(360deg);}}';
    document.head.appendChild(st);
  }

  /* ------------------------------------------------------------------ *
   * ① 照合（バッジ・ドロワーの行）
   * ------------------------------------------------------------------ */

  function badgeCount() {
    var el = $('cart-icon .cart-bubble__text-count');
    if (!el) return null;
    var n = parseInt(el.textContent, 10);
    return isNaN(n) ? 0 : n;
  }

  function syncBadge(cart) {
    var n = shownCount(cart);
    if (badgeCount() === n) return;
    if (dispatchCartUpdate(cart)) return;
    var el = $('cart-icon .cart-bubble__text-count');
    var bubble = $('cart-icon .cart-bubble');
    var icon = $('cart-icon');
    if (el) el.textContent = n < 100 ? String(n) : '';
    if (el) el.classList.toggle('hidden', n === 0);
    if (bubble) bubble.classList.toggle('visually-hidden', n === 0);
    if (icon) icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
  }

  function drawerRows() {
    var d = drawer();
    if (!d) return [];
    return $$('cart-items-component .cart-items__table-row[data-key]', d);
  }

  /** ドロワーの行が /cart.js と一致しているか（key と数量） */
  function drawerMatches(cart) {
    var d = drawer();
    if (!d) return true;
    var rows = drawerRows();
    var items = cart.items || [];
    if (rows.length !== items.length) return false;
    var byKey = {};
    items.forEach(function (it) { byKey[it.key] = it.quantity; });
    for (var i = 0; i < rows.length; i++) {
      var key = rows[i].dataset.key;
      if (!(key in byKey)) return false;
      var input = rows[i].querySelector('input[type="number"], input[name="updates[]"]');
      if (input && parseInt(input.value, 10) !== byKey[key]) return false;
    }
    return true;
  }

  function rerenderDrawer() {
    var d = drawer();
    var comp = d && d.querySelector('cart-items-component');
    var sectionId = comp && comp.dataset.sectionId;
    if (!sectionId) return Promise.resolve(false);

    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status)); })
      .then(function (html) {
        if (sectionRenderer && sectionRenderer.morphSection) {
          sectionRenderer.morphSection(sectionId, html, 'hydration', { injectStylesheet: true });
          return true;
        }
        // フォールバック: cart-items-component の中身だけ差し替える
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer-component cart-items-component');
        var cur = drawer() && drawer().querySelector('cart-items-component');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; return true; }
        return false;
      })
      .catch(function (e) { warn('[cart-drawer-fix] ドロワーの再描画に失敗', e); return false; });
  }

  /* ------------------------------------------------------------------ *
   * ② GPO の子行
   * ------------------------------------------------------------------ */

  var lastCart = null;

  /* ------------------------------------------------------------------ *
   * ⑨ ライン属性名の整形（表示のみ）
   *   GPO の label_on_cart は同名要素の区別に末尾 a〜z（1〜2 文字）が付く。全角文字直後のものだけ落とす。
   *   半角のみのキーは辞書で置換。集計: claude/購買導線UX監査_初心者向け改善提案_2026-09-04.md K2
   * ------------------------------------------------------------------ */

  var PROP_LABELS = {
    'fastpass': 'カスタム ファストパス チケット',
    'con': '接続端子',
    'addop': '追加施工',
    'GGETU': 'G&G 電子トリガーETU',
    'number-1': '長さ',
    'dropdown-8': 'ご依頼機種',
    'radio-8': '内部カスタム',
    'checkbox-11': '強化ギア',
    'radio-11': '区分1', 'radio-12': '区分2', 'radio-13': '区分3', 'radio-14': '区分4',
    'radio-15': '区分5', 'radio-16': '区分6', 'radio-17': '区分7', 'radio-18': '区分8'
  };

  function displayPropName(key) {
    key = String(key || '').trim();
    if (PROP_LABELS.hasOwnProperty(key)) return PROP_LABELS[key];
    return key.replace(/([^\x00-\x7f])[a-z]{1,2}$/, '$1');
  }

  function tidyPropertyLabels(root) {
    $$('.cart-items__property dt', root).forEach(function (dt) {
      var raw = dt.getAttribute('data-a97-raw');
      if (raw === null) {
        raw = dt.textContent.replace(/[:：]\s*$/, '').trim();
        dt.setAttribute('data-a97-raw', raw);
      }
      var shown = displayPropName(raw) + ':';
      if (dt.textContent !== shown) dt.textContent = shown;
    });
  }

  /** 子行の印付け対象。ドロワーとカートページの両方（カートページは親削除時に子行も即時に消すため） */
  function allRows() {
    return $$('cart-items-component .cart-items__table-row[data-key]');
  }

  function markChildRows(cart) {
    if (!cart) return;
    var items = cart.items || [];
    var groupToParentKey = {};
    items.forEach(function (it) {
      var p = it.properties || {};
      if (p._gpo_product_group && !p._gpo_parent_product_group) groupToParentKey[p._gpo_product_group] = it.key;
    });
    var childToParent = {};
    var mixOf = {};
    items.forEach(function (it) {
      var p = it.properties || {};
      if (p._gpo_parent_product_group) {
        childToParent[it.key] = groupToParentKey[p._gpo_parent_product_group] || '';
        if ('_gpo_quantity_mix' in p) mixOf[it.key] = parseInt(p._gpo_quantity_mix, 10) || 1;
      }
    });

    allRows().forEach(function (row) {
      var key = row.dataset.key;
      if (!(key in childToParent)) {
        row.classList.remove(CHILD_CLASS);
        row.classList.remove(CHILD_EDITABLE_CLASS);
        return;
      }
      row.classList.add(CHILD_CLASS);
      row.classList.toggle(CHILD_EDITABLE_CLASS, key in mixOf);
      // テーマの onLineItemRemove は data-parent-key が親の data-key と一致する行を一緒に消す
      if (childToParent[key] && row.dataset.parentKey !== childToParent[key]) row.dataset.parentKey = childToParent[key];
      if (row.closest('cart-drawer-component')) {
        var note = row.querySelector('.' + NOTE_CLASS);
        if (!note) {
          var details = row.querySelector('.cart-items__details') || row;
          note = document.createElement('p');
          note.className = NOTE_CLASS;
          details.appendChild(note);
        }
        var text = key in mixOf ? NOTE_TEXT_EDITABLE.replace('{n}', mixOf[key]) : NOTE_TEXT;
        if (note.textContent !== text) note.textContent = text;
      }
    });
    ensureClearControl();
    tidyPropertyLabels();
  }

  /* ------------------------------------------------------------------ *
   * ③ 通信の監視 → 落ち着いたら照合
   * ------------------------------------------------------------------ */

  var inflight = 0;
  var quietTimer = null;
  var maxTimer = null;
  var wasOpen = false;        // 変更が始まった時点でドロワーが開いていたか
  var userClosed = false;     // 変更の途中で利用者が自分で閉じたか
  var reconciling = false;
  var rerun = false;

  // GPO は子行の数量を合わせたあと location.reload() する（実測）。読み込み直後の
  // ページはその通信が終わる前に描画されることがあるので、変更中だった印を
  // sessionStorage に残し、次の読み込みで一度だけ照合する。
  var PENDING_KEY = 'a97-cart-pending';

  function markPending() {
    try {
      sessionStorage.setItem(PENDING_KEY, JSON.stringify({ t: Date.now(), open: wasOpen && !userClosed }));
    } catch (e) {}
  }
  function clearPending() {
    try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
  }
  function readPending() {
    try {
      var v = sessionStorage.getItem(PENDING_KEY);
      if (!v) return null;
      var o = JSON.parse(v);
      return (o && Date.now() - o.t < 60000) ? o : null;
    } catch (e) { return null; }
  }

  function onCartRequestStart() {
    installGpoReconcileGuard();
    if (inflight === 0) {
      wasOpen = isOpen();
      userClosed = false;
      if (!maxTimer) maxTimer = setTimeout(function () { maxTimer = null; scheduleReconcile(0); }, MAX_WAIT_MS);
    }
    inflight++;
    markPending();
    clearTimeout(quietTimer);
  }

  function onCartRequestEnd() {
    inflight = Math.max(0, inflight - 1);
    if (inflight === 0) scheduleReconcile(QUIET_MS);
  }

  function scheduleReconcile(ms) {
    clearTimeout(quietTimer);
    quietTimer = setTimeout(reconcile, ms);
  }

  function reconcile() {
    if (reconciling) { rerun = true; return; }
    reconciling = true;
    clearTimeout(maxTimer); maxTimer = null;

    var reopen = wasOpen && !userClosed;
    wasOpen = false;

    loadThemeModules()
      .then(getCart)
      .then(function (cart) {
        lastCart = cart;
        syncBadge(cart);
        if (!drawer()) { markChildRows(cart); return; }   // カートページ
        var p = drawerMatches(cart) ? Promise.resolve(false) : rerenderDrawer();
        return p.then(function () {
          syncEmptyClass();
          markChildRows(cart);
          if (reopen && !isOpen()) {
            var d = drawer();
            if (d && typeof d.open === 'function') d.open();
          }
        });
      })
      .catch(function (e) { warn('[cart-drawer-fix] 照合に失敗', e); })
      .then(function () {
        reconciling = false;
        if (inflight === 0) { clearPending(); unlockCart(); hideAdding(false); }
        if (rerun) { rerun = false; scheduleReconcile(QUIET_MS); }
      });
  }

  // fetch
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var hit = CART_RE.test(url);
      var isAdd = hit && ADD_RE.test(url);
      var injected = false;
      var addBody = null;
      if (isAdd && init && typeof init.body === 'string') {
        // GPO の追加リクエスト。sections を足して応答で即描画できるようにする
        try {
          var body = JSON.parse(init.body);
          if (body && typeof body === 'object') addBody = body;
          if (body && typeof body === 'object' && !body.sections && drawer()) {
            body.sections = allSectionIds().join(',');
            body.sections_url = window.location.pathname;
            init = Object.assign({}, init, { body: JSON.stringify(body) });
            arguments[1] = init;
            injected = true;
          }
        } catch (e) {}
      }
      var rb = hit && !isAdd ? filterRolledBack(url, init) : null;
      if (rb && rb.init) { init = rb.init; arguments[1] = init; }
      if (hit) onCartRequestStart();
      if (isAdd && takeAddIntent()) showAdding();
      var p = rb && rb.skip
        ? origFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        : origFetch.apply(this, arguments);
      var group = gpoGroupOf(addBody);
      if (group) {
        p = p.then(function (r) { return r && r.status === 422 ? undoPartialGpoAdd(r, addBody, group) : r; });
      }
      if (hit) p.then(onCartRequestEnd, onCartRequestEnd);
      if (isAdd) p.then(function (r) { if (r && r.ok) r.clone().json().then(function (j) { afterAdd(j, injected); }, function () {}); }, function () {});
      return p;
    };
  }

  // XMLHttpRequest（jQuery.ajax 経由の GPO 用）
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__a97cart = CART_RE.test(String(url));
      this.__a97add = ADD_RE.test(String(url));
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__a97cart) {
        onCartRequestStart();
        if (this.__a97add && takeAddIntent()) showAdding();
        this.addEventListener('loadend', onCartRequestEnd, { once: true });
      }
      return origSend.apply(this, arguments);
    };
  }

  // テーマ自身のカート更新（通信を経ないケースの保険）
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.data && e.detail.data.source === SOURCE) return;
    if (typeof hideAdding === 'function') hideAdding(false);   // テーマが中身を描いた時点で追加中表示を外す
    scheduleReconcile(QUIET_MS);
  });

  /* ------------------------------------------------------------------ *
   * ⑫ 在庫不足で一部だけ入った GPO の追加を取り消す
   * ------------------------------------------------------------------ */

  /** ついで買い（子行）を含む GPO の追加なら、親子をつなぐグループ ID を返す */
  function gpoGroupOf(body) {
    var items = body && Array.isArray(body.items) ? body.items : null;
    if (!items) return null;
    for (var i = 0; i < items.length; i++) {
      var p = (items[i] && items[i].properties) || {};
      if (p._gpo_parent_product_group) return String(p._gpo_parent_product_group);
    }
    return null;
  }

  function inGroup(it, group) {
    var p = it.properties || {};
    return String(p._gpo_product_group || '') === group || String(p._gpo_parent_product_group || '') === group;
  }

  function addonTitle(id) {
    var list = (window.GPOConfigs && window.GPOConfigs.addonVariants) || [];
    for (var i = 0; i < list.length; i++) if (Number(list[i].id) === id) return list[i].product_title || '';
    return '';
  }

  /** 足りなかった商品ごとの案内文。cart は一部追加の直後（取り消し前）のもの */
  function stockMessage(body, cart, groupLines) {
    var parts = [];
    (body.items || []).forEach(function (req) {
      var id = Number(req && req.id);
      var want = Number(req && req.quantity) || 0;
      if (!id || !want) return;
      var got = 0, total = 0, title = '';
      (cart.items || []).forEach(function (it) {
        if (Number(it.variant_id) !== id) return;
        total += it.quantity;
        if (!title) title = it.product_title || '';
        if (groupLines.indexOf(it) !== -1) got += it.quantity;
      });
      if (got >= want) return;
      title = title || addonTitle(id) || 'ご指定の商品';
      var other = total - got;
      var msg;
      if (total <= 0) msg = STOCK_MSG_NONE;
      else if (other > 0) msg = STOCK_MSG_SHORT_INCART.replace('{m}', other);
      else msg = STOCK_MSG_SHORT;
      parts.push(msg.replace('{title}', title).replace('{n}', total));
    });
    return parts.join('\n\n');
  }

  /**
   * /cart/add.js は在庫を超えた分を削って入れ、422 を返す（親の表示用プロパティは選んだ個数のまま）。
   * 今回の追加で入った親子をグループ ID で探して 0 に戻し、GPO が alert する応答を日本語の案内に差し替える。
   */
  function undoPartialGpoAdd(res, body, group) {
    return res.clone().json().catch(function () { return null; }).then(function (orig) {
      return getCart().then(function (cart) {
        var lines = (cart.items || []).filter(function (it) { return inGroup(it, group); });
        if (!lines.length) return res;
        var updates = {};
        lines.forEach(function (it) { updates[it.key] = 0; });
        var msg = stockMessage(body, cart, lines) || (orig && orig.description) || STOCK_MSG_FALLBACK;
        suppressGpoReconcile();
        return postCart('/cart/update.js', { updates: updates }).then(function () {
          rememberRolledBack(Object.keys(updates));
          hideAdding(true);
          return new Response(JSON.stringify({ status: 422, message: msg, description: msg }), {
            status: 422,
            headers: { 'Content-Type': 'application/json' }
          });
        });
      });
    }).catch(function (e) {
      warn('[cart-drawer-fix] 在庫不足の追加を取り消せませんでした', e);
      return res;
    });
  }

  /**
   * 取り消した行への GPO の後追い（約6秒後の /cart/change.js、約12秒後の照合の /cart/update.js）を止める。
   * 消えた行のキーは Shopify が同じバリアントの別の行に当てるため、放っておくと既存の行の数量が書き換わる（実測）。
   */
  var ROLLBACK_BLOCK_MS = 60000;
  var rolledBack = {};   // 行キー → 期限

  function rememberRolledBack(keys) {
    var until = Date.now() + ROLLBACK_BLOCK_MS;
    keys.forEach(function (k) { rolledBack[k] = until; });
  }
  function isRolledBack(key) {
    var t = rolledBack[key];
    if (!t) return false;
    if (Date.now() > t) { delete rolledBack[key]; return false; }
    return true;
  }

  /** 取り消した行を指すなら外す。外して何も残らなければ { skip }、一部だけ外したなら { init } */
  function filterRolledBack(url, init) {
    if (!init || typeof init.body !== 'string') return null;
    var body;
    try { body = JSON.parse(init.body); } catch (e) { return null; }
    if (!body || typeof body !== 'object') return null;
    if (/\/cart\/change/.test(url)) {
      return (typeof body.id === 'string' && isRolledBack(body.id)) ? { skip: true } : null;
    }
    if (/\/cart\/update/.test(url) && body.updates && typeof body.updates === 'object' && !Array.isArray(body.updates)) {
      var dropped = false;
      Object.keys(body.updates).forEach(function (k) {
        if (isRolledBack(k)) { delete body.updates[k]; dropped = true; }
      });
      if (!dropped) return null;
      var other = Object.keys(body).some(function (k) { return k !== 'updates' && k !== 'sections' && k !== 'sections_url'; });
      if (!Object.keys(body.updates).length && !other) return { skip: true };
      return { init: Object.assign({}, init, { body: JSON.stringify(body) }) };
    }
    return null;
  }

  /** GPO の事前在庫チェックの文言（既定は英語）。GPOConfigs は作り直されることがあるので都度当てる */
  function ensureGpoMessages() {
    window.gpoCustomInventoryMsg = GPO_MSG_INVENTORY;
    var G = window.GPOConfigs;
    if (!G) return;
    try {
      if (!G.translations || typeof G.translations !== 'object') G.translations = {};
      if (!G.translations.addtocart || typeof G.translations.addtocart !== 'object') G.translations.addtocart = {};
      G.translations.addtocart.items_are_no_longer_available = GPO_MSG_SOLDOUT;
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ *
   * ④ 子行を持つ親の削除・数量変更は、親子まとめて 1 回の /cart/update.js で行う
   *   テーマ → GPO の順に処理すると「親だけ消える → 数秒後に GPO が子を消して reload」になる。
   *   親子を同時に更新すれば GPO の後始末が要らず reload も起きない。処理中は覆いで操作を止める。
   * ------------------------------------------------------------------ */

  var LOCK_ID = 'a97-cart-lock';
  var LOCK_MAX_MS = 8000;
  var lockTimer = null;

  function lockCart(label) {
    var el = document.getElementById(LOCK_ID);
    // ドロワー（showModal の top layer）が開いているときは、その中に置かないと隠れる
    var host = isOpen() ? dialogOf(drawer()) : document.body;
    if (el && el.parentElement !== host) { el.remove(); el = null; }
    if (!el) {
      el = document.createElement('div');
      el.id = LOCK_ID;
      el.className = 'a97-cart-lock' + (host !== document.body ? ' a97-cart-lock--in-dialog' : '');
      el.setAttribute('role', 'status');
      host.appendChild(el);
    }
    el.setAttribute('aria-label', label || '更新しています');
    clearTimeout(lockTimer);
    lockTimer = setTimeout(unlockCart, LOCK_MAX_MS);   // 保険。必ず解除する
  }
  function unlockCart() {
    clearTimeout(lockTimer); lockTimer = null;
    var el = document.getElementById(LOCK_ID);
    if (el) el.remove();
  }

  function childRowsOf(comp, key) {
    return $$('.cart-items__table-row[data-parent-key="' + key + '"]', comp);
  }

  function allSectionIds() {
    var ids = [];
    $$('cart-items-component[data-section-id]').forEach(function (c) {
      if (ids.indexOf(c.dataset.sectionId) === -1) ids.push(c.dataset.sectionId);
    });
    return ids;
  }

  /** GPO のカート照合（reconcile）を一定時間止める。こちらで整合を取った直後に、
   *  古いレプリカを読んだ GPO が余計な /cart/update.js と reload を走らせるのを防ぐ。 */
  var GPO_SKIP_MS = 10000;
  var gpoSkipUntil = 0;

  /** GPO のカート照合（reconcileCart）を一定時間素通りさせる。
   *  reconcileCart は GPO がカート連携モジュールを読み込んだ時点で GPOConfigs に Object.assign されるため、
   *  アクセサで受けておき、いつ代入されても包んだ状態を保つ。 */
  function installGpoReconcileGuard() {
    var G = window.GPOConfigs;
    if (!G) return;
    // GPO は GPOConfigs を作り直す（複製する）ことがあり、そのときアクセサは値に戻る。旗ではなく記述子で判定する
    ['reconcileCart', 'performCartReconcile'].forEach(function (name) {
      var desc = Object.getOwnPropertyDescriptor(G, name);
      if (desc && desc.get && desc.get.__a97) return;
      var orig = G[name];
      var getter = function () {
        if (typeof orig !== 'function') return orig;
        return function () {
          if (Date.now() < gpoSkipUntil) return Promise.resolve(false);
          return orig.apply(this, arguments);
        };
      };
      getter.__a97 = true;
      try {
        Object.defineProperty(G, name, { configurable: true, enumerable: true, get: getter, set: function (fn) { orig = fn; } });
      } catch (e) {}
    });
  }
  function suppressGpoReconcile() {
    gpoSkipUntil = Date.now() + GPO_SKIP_MS;
    installGpoReconcileGuard();
  }

  /** /cart/*.js の応答（sections 付き）でテーマのセクションを描き直し、バッジと子行の印を揃える */
  function renderFromCart(cart, ids) {
    return loadThemeModules().then(function () {
      var sections = cart.sections || {};
      ids.forEach(function (id) {
        if (!sections[id]) return;
        var c = $('cart-items-component[data-section-id="' + id + '"]');
        var inDrawer = !!(c && c.closest('cart-drawer-component'));
        if (sectionRenderer && sectionRenderer.morphSection) {
          sectionRenderer.morphSection(id, sections[id], inDrawer ? 'hydration' : 'full', { injectStylesheet: true });
        }
      });
      dispatchCartUpdate(cart, { sections: sections });
      syncEmptyClass();
      lastCart = cart;
      markChildRows(cart);
      syncBadge(cart);
      // cart-fix.js が先に掛けた不可視化を戻す（空カート以外は自動では戻らない）
      $$('cart-items-component.__cf-hiding').forEach(function (c) { c.classList.remove('__cf-hiding'); });
    });
  }

  function postCart(path, payload) {
    return fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); });
  }

  /** GPO の照合式（performCartReconcile）と同じ、親の数量に対する子の数量 */
  function expectedChildQty(childProps, parentQty) {
    var p = childProps || {};
    if ('_gpo_one_time_charge' in p) return 1;
    if ('_gpo_quantity_fixed' in p) return parseInt(p._gpo_quantity_fixed, 10) || 1;
    if ('_gpo_quantity_dynamic' in p) return parseInt(p._gpo_quantity_dynamic * parentQty, 10) || parentQty;
    if ('_gpo_quantity_mix' in p) return parseInt(p._gpo_quantity_mix * parentQty, 10) || parentQty;
    if ('_gpo_per_character' in p) return parseInt(p._gpo_per_character * parentQty, 10) || parentQty;
    return parentQty;
  }

  function findItem(cart, key) {
    var found = null;
    (cart && cart.items || []).forEach(function (it) { if (it.key === key) found = it; });
    return found;
  }

  /** 親子まとめて更新し、テーマのセクションを描き直してバッジを更新する */
  function updateFamily(comp, parentRow, quantity) {
    var key = parentRow.dataset.key;
    var childKeys = childRowsOf(comp, key).map(function (row) { return row.dataset.key; });
    var ids = allSectionIds();

    lockCart(quantity === 0 ? '削除しています' : '数量を変更しています');
    // 行の input はテーマが先に書き換えるので数量の元は /cart.js（手元の写しに無ければ読み直す）
    var have = lastCart && findItem(lastCart, key) && childKeys.every(function (k) { return findItem(lastCart, k); });
    return (have ? Promise.resolve(lastCart) : getCart())
      .then(function (cart) {
        var updates = {};
        updates[key] = quantity;
        childKeys.forEach(function (k) {
          var child = findItem(cart, k);
          updates[k] = quantity === 0 ? 0 : expectedChildQty(child && child.properties, quantity);
        });
        suppressGpoReconcile();
        return postCart('/cart/update.js', { updates: updates, sections: ids.join(','), sections_url: window.location.pathname });
      })
      .then(function (cart) { return renderFromCart(cart, ids); })
      .catch(function (e) {
        warn('[cart-drawer-fix] 親子の更新に失敗。ページを読み直します', e);
        window.location.reload();
      })
      .then(unlockCart);
  }

  /**
   * ついで買い商品（子行）の数量変更。商品ページで数量を選べた子（_gpo_quantity_mix 持ち）だけ。
   * GPO は「子の数量 = 親の数量 × mix」で照合するので、mix を書き換えて親の表示用プロパティも合わせる。
   * 子の数量は親の数量の倍数に丸める（GPO の照合式と同じ）。
   */
  var hintTimer = null;
  function showChildHint(row, text) {
    var details = row.querySelector('.cart-items__details') || row;
    var el = details.querySelector('.' + HINT_CLASS);
    if (!el) {
      el = document.createElement('p');
      el.className = HINT_CLASS;
      el.setAttribute('role', 'alert');
      details.appendChild(el);
    }
    el.textContent = text;
    clearTimeout(hintTimer);
    hintTimer = setTimeout(function () { $$('.' + HINT_CLASS).forEach(function (e) { e.remove(); }); }, 4000);
  }

  function updateChildQty(comp, childRow, quantity) {
    lockCart('数量を変更しています');
    // 表示中の行が古いことがある（テーマ側の変更後など）ので、必ず /cart.js を読み直してから組み立てる
    return getCart().then(function (cart) { return updateChildQtyWith(cart, childRow, quantity); })
      .catch(function (e) {
        warn('[cart-drawer-fix] 子行の数量変更に失敗。ページを読み直します', e);
        window.location.reload();
      })
      .then(unlockCart);
  }

  function updateChildQtyWith(cart, childRow, quantity) {
    var child = null, parent = null;
    (cart.items || []).forEach(function (it) { if (it.key === childRow.dataset.key) child = it; });
    if (!child || !child.properties || !('_gpo_quantity_mix' in child.properties)) return Promise.resolve();
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties._gpo_product_group === child.properties._gpo_parent_product_group) parent = it;
    });
    if (!parent) return Promise.resolve();

    var curMix = parseInt(child.properties._gpo_quantity_mix, 10) || 1;
    var delta = quantity - child.quantity;
    var mix;
    if (Math.abs(delta) === 1) mix = curMix + delta;                          // ＋／－ボタンは 1 段ずつ
    else mix = Math.round(quantity / parent.quantity);                       // 直接入力は最も近い倍数
    mix = Math.max(1, mix);
    var newQty = mix * parent.quantity;
    var ids = allSectionIds();
    if (newQty === child.quantity) {                                         // 変わらない（下限）
      var input = childRow.querySelector('input[type="number"], input[name="updates[]"]');
      if (input) input.value = child.quantity;
      // テーマは input が下限に触れた時点で − を disabled にする。値を戻したので有効に戻す
      $$('button.quantity-minus, button.quantity-plus', childRow).forEach(function (b) { b.disabled = false; });
      if (quantity < child.quantity) showChildHint(childRow, HINT_MIN);
      return Promise.resolve();
    }

    var childProps = {};
    Object.keys(child.properties).forEach(function (k) { childProps[k] = child.properties[k]; });
    childProps._gpo_quantity_mix = typeof child.properties._gpo_quantity_mix === 'number' ? mix : String(mix);

    var field = child.properties._gpo_field_name;
    var parentProps = null;
    if (field && parent.properties && typeof parent.properties[field] === 'string') {
      parentProps = {};
      Object.keys(parent.properties).forEach(function (k) { parentProps[k] = parent.properties[k]; });
      // 表示用の値は「選択肢の名前 | 個数」。同じ項目に子が 1 つだけのときは末尾の個数を差し替え、
      // 複数あって（"A | 1, B | 2" のように）どれがこの子か特定できないときは触らない
      var v = parent.properties[field];
      var siblings = (cart.items || []).filter(function (it) {
        return it.properties && it.properties._gpo_parent_product_group === child.properties._gpo_parent_product_group &&
          it.properties._gpo_field_name === field;
      });
      if (siblings.length === 1 && /^[^|]*\|\s*\d+\s*$/.test(v)) parentProps[field] = v.replace(/(\|\s*)\d+\s*$/, '$1' + mix);
      else parentProps = null;
    }

    suppressGpoReconcile();
    var sec = { sections: ids.join(','), sections_url: window.location.pathname };
    // 最後の /cart/change.js に sections を付けて描画用 HTML をもらう（往復を 1 回減らす）
    var childReq = { id: child.key, quantity: newQty, properties: childProps };
    if (!parentProps) { childReq.sections = sec.sections; childReq.sections_url = sec.sections_url; }
    return postCart('/cart/change.js', childReq)
      .then(function (c) {
        if (!parentProps) return c;
        return postCart('/cart/change.js', { id: parent.key, quantity: parent.quantity, properties: parentProps, sections: sec.sections, sections_url: sec.sections_url });
      })
      .then(function (c) { return renderFromCart(c, ids); });
  }

  // 削除ボタン（テーマの on:click は document のキャプチャで先に動くため、window で先回りする）
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var btn = t.closest('.cart-items__remove');
    if (!btn) return;
    var row = btn.closest('.cart-items__table-row[data-key]');
    var comp = btn.closest('cart-items-component');
    if (!row || !comp) return;
    if (row.classList.contains(CHILD_EDITABLE_CLASS)) {        // 個数を選べた子だけ単独で外せる
      e.preventDefault();
      e.stopImmediatePropagation();
      removeChild(row);
      return;
    }
    if (!childRowsOf(comp, row.dataset.key).length) return;   // 子行が無ければテーマに任せる
    e.preventDefault();
    e.stopImmediatePropagation();
    updateFamily(comp, row, 0);
  }, true);

  /**
   * 子行だけを外す。親の表示用プロパティ（例 `ご一緒にいかがですか？: "CO2カートリッジ 6本 | 2"`）も合わせて外す。
   * 同じ項目に子が複数あって、この子の分が特定できないときは親のプロパティは触らない。
   */
  function removeChild(childRow) {
    lockCart('削除しています');
    return getCart().then(function (cart) {
      var child = findItem(cart, childRow.dataset.key);
      if (!child || !child.properties) return null;
      var parent = null;
      (cart.items || []).forEach(function (it) {
        if (it.properties && it.properties._gpo_product_group === child.properties._gpo_parent_product_group) parent = it;
      });
      var ids = allSectionIds();
      var sec = { sections: ids.join(','), sections_url: window.location.pathname };
      var parentProps = null;
      var field = child.properties._gpo_field_name;
      if (parent && field && parent.properties && typeof parent.properties[field] === 'string') {
        var siblings = (cart.items || []).filter(function (it) {
          return it.properties && it.properties._gpo_parent_product_group === child.properties._gpo_parent_product_group &&
            it.properties._gpo_field_name === field;
        });
        if (siblings.length === 1) {
          parentProps = {};
          Object.keys(parent.properties).forEach(function (k) { if (k !== field) parentProps[k] = parent.properties[k]; });
        }
      }
      suppressGpoReconcile();
      var childReq = { id: child.key, quantity: 0 };
      if (!parentProps) { childReq.sections = sec.sections; childReq.sections_url = sec.sections_url; }
      return postCart('/cart/change.js', childReq).then(function (c) {
        if (!parentProps) return c;
        return postCart('/cart/change.js', { id: parent.key, quantity: parent.quantity, properties: parentProps, sections: sec.sections, sections_url: sec.sections_url });
      }).then(function (c) { return renderFromCart(c, ids); });
    }).catch(function (e) {
      warn('[cart-drawer-fix] 子行の削除に失敗。ページを読み直します', e);
      window.location.reload();
    }).then(unlockCart);
  }

  // 数量セレクタ（テーマは quantity-selector:update を受けて /cart/change.js を呼ぶ）
  window.addEventListener('quantity-selector:update', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var row = t.closest('.cart-items__table-row[data-key]');
    var comp = t.closest('cart-items-component');
    if (!row || !comp) return;
    var q = e.detail && typeof e.detail.quantity === 'number' ? e.detail.quantity : NaN;
    if (isNaN(q) || q < 0) return;
    if (childRowsOf(comp, row.dataset.key).length) {          // 子行を持つ親
      e.stopImmediatePropagation();
      updateFamily(comp, row, q);
    } else if (row.classList.contains(CHILD_EDITABLE_CLASS)) {  // 数量を変えられる子
      e.stopImmediatePropagation();
      updateChildQty(comp, row, q);   // 0 は下限に丸められて何もしない（子だけの削除は親側で外す）
    }
  }, true);

  /* ------------------------------------------------------------------ *
   * ⑧ カートを空にする（確認モーダル付き）
   *   万一 GPO の子行だけが残っても利用者が自分でカートを空にできるようにする。
   * ------------------------------------------------------------------ */

  function ensureClearControl() {
    var hosts = [];
    var d = drawer();
    // ドロワーは商品一覧（スクロール領域）の末尾。合計・注文手続きの下には置かない
    if (d) hosts.push(d.querySelector('.cart-drawer__items') || d.querySelector('.cart-drawer__content') || dialogOf(d));
    if (!d || /^\/cart(\/|$)/.test(window.location.pathname)) {
      $$('cart-items-component').forEach(function (c) {
        if (!c.closest('cart-drawer-component')) hosts.push(c.querySelector('.cart-page__items') || c.parentElement);
      });
    }
    // 出す・消すは画面の行の有無で決める（/cart.js の写しは削除直後に古いことがある）
    hosts.forEach(function (host) {
      if (!host) return;
      var comp = host.closest('cart-items-component') || host.querySelector('cart-items-component') || host;
      var show = !!comp.querySelector('.cart-items__table-row[data-key]');
      var el = host.querySelector(':scope > .' + CLEAR_CLASS);
      if (!show) { if (el) el.remove(); return; }
      if (el) return;
      el = document.createElement('div');
      el.className = CLEAR_CLASS;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = 'カートを空にする';
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openClearDialog(); });
      el.appendChild(btn);
      host.appendChild(el);
    });
    // 置き場所ごと差し替わって残った分
    $$('.' + CLEAR_CLASS).forEach(function (el) {
      if (hosts.indexOf(el.parentElement) === -1) el.remove();
    });
  }

  function openClearDialog() {
    var dlg = document.getElementById(CLEAR_CLASS + '-dialog');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.id = CLEAR_CLASS + '-dialog';
      dlg.className = CLEAR_CLASS + '-dialog';
      dlg.setAttribute('aria-labelledby', CLEAR_CLASS + '-title');
      dlg.innerHTML =
        '<h2 id="' + CLEAR_CLASS + '-title">カートを空にしますか？</h2>' +
        '<p>カートに入っている商品をすべて削除します。<br>この操作は取り消せません。</p>' +
        '<div class="' + CLEAR_CLASS + '-dialog__actions">' +
        '<button type="button" data-a97-cancel>キャンセル</button>' +
        '<button type="button" data-a97-confirm>すべて削除する</button>' +
        '</div>';
      // 中のクリックがドロワーの「外側クリックで閉じる」に拾われないようにする
      dlg.addEventListener('click', function (e) {
        e.stopPropagation();
        if (e.target === dlg) dlg.close();   // 背景クリックで閉じる
      });
      dlg.querySelector('[data-a97-cancel]').addEventListener('click', function () { dlg.close(); });
      dlg.querySelector('[data-a97-confirm]').addEventListener('click', function () { dlg.close(); clearCart(); });
      document.body.appendChild(dlg);
    }
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else if (window.confirm('カートの商品をすべて削除します。この操作は取り消せません。よろしいですか？')) clearCart();
  }

  function clearCart() {
    var ids = allSectionIds();
    $$('.' + CLEAR_CLASS).forEach(function (el) { el.remove(); });
    lockCart('カートを空にしています');
    suppressGpoReconcile();
    return postCart('/cart/clear.js', {})
      .then(function () {
        return postCart('/cart/update.js', { updates: {}, sections: ids.join(','), sections_url: window.location.pathname });
      })
      .then(function (c) { return renderFromCart(c, ids); })
      .catch(function (e) {
        warn('[cart-drawer-fix] カートを空にできませんでした。ページを読み直します', e);
        window.location.reload();
      })
      .then(unlockCart);
  }

  /* ------------------------------------------------------------------ *
   * ⑤ /cart/add の送信が始まったらドロワーを開く（応答を待たない）
   *   中身を隠して、追加中の商品画像・商品名と「追加しています…」だけを見せる。
   *   GPO の検証で止まった追加は送信されないので、ここには来ない。
   * ------------------------------------------------------------------ */

  var ADDING_CLASS = 'a97-cart-adding';
  var ADDING_TEXT = 'カートに追加しています…';
  var addingTimer = null;
  var adding = false;
  var openedForAdd = false;   // こちらが開いたドロワーか（追加に失敗したとき閉じ戻す判断に使う）

  function pendingProduct() {
    var title = '';
    var img = '';
    try {
      var h1 = $('.product-information h1, product-title h1, h1');
      title = h1 ? h1.textContent.trim() : '';
      var pic = $('media-gallery img, .product-media img, slideshow-slide img');
      img = pic ? (pic.currentSrc || pic.src || '') : '';
    } catch (e) {}
    return { title: title, img: img };
  }

  /** 追加中の表示を差し込む。テーマの morph で消されたら watchDrawer が差し込み直す */
  function ensureAddingOverlay() {
    var d = drawer();
    if (!d) return;
    var content = d.querySelector('.cart-drawer__content') || d.querySelector('dialog') || d;
    if (content.querySelector('.' + ADDING_CLASS)) return;
    var p = pendingProduct();
    var el = document.createElement('div');
    el.className = ADDING_CLASS;
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<span class="' + ADDING_CLASS + '__spinner" aria-hidden="true"></span>' +
      (p.img ? '<img class="' + ADDING_CLASS + '__img" alt="" src="' + p.img.replace(/"/g, '&quot;') + '">' : '') +
      (p.title ? '<div class="' + ADDING_CLASS + '__title"></div>' : '') +
      '<div class="' + ADDING_CLASS + '__status">' + ADDING_TEXT + '</div>';
    if (p.title) el.querySelector('.' + ADDING_CLASS + '__title').textContent = p.title;
    content.insertBefore(el, content.firstChild);
  }

  /** ドロワーの中身を全部隠し、追加中の表示だけを出す。/cart/add の送信開始時に呼ぶ */
  function showAdding() {
    var d = drawer();
    if (!d || !d.hasAttribute('auto-open')) return;
    adding = true;
    document.body.classList.add('a97-adding');
    ensureAddingOverlay();
    if (!isOpen()) {
      openedForAdd = true;
      if (typeof d.open === 'function') d.open();
    }
    clearTimeout(addingTimer);
    addingTimer = setTimeout(function () { hideAdding(false); }, 10000);
  }
  function hideAdding(closeIfOpenedHere) {
    clearTimeout(addingTimer); addingTimer = null;
    adding = false;
    document.body.classList.remove('a97-adding');
    $$('.' + ADDING_CLASS).forEach(function (el) { el.remove(); });
    var d = drawer();
    if (closeIfOpenedHere && openedForAdd && d && typeof d.close === 'function') {
      try { d.close(); } catch (e) {}
    }
    openedForAdd = false;
  }

  /** /cart/add の応答。sections があれば即描画、無ければドロワーのセクションを読み直す */
  function afterAdd(json, injected) {
    if (!drawer()) return;
    if (json && json.sections && !injected) return;   // テーマ自身の追加。描画後の cart:update で片付く
    var ids = allSectionIds();
    var p = json && json.sections ? renderSections(json.sections, ids) : rerenderDrawer();
    p.then(function () {
      // 応答の items で先に子行の印を付ける（/cart.js を待つと、その間だけ数量ボタンが見える）
      var added = json && (Array.isArray(json.items) ? json.items : (json.key ? [json] : []));
      if (added.length) {
        var items = (lastCart && lastCart.items || []).filter(function (it) {
          return !added.some(function (a) { return a.key === it.key; });
        }).concat(added);
        lastCart = { items: items, item_count: items.reduce(function (n, it) { return n + (it.quantity || 0); }, 0) };
        markChildRows(lastCart);
      }
      // 利用者のカート追加（showAdding 済み）のときだけ開く。まとめて配送の目印の追加などでは開かない
      var d = drawer();
      if (adding && d && d.hasAttribute('auto-open') && !isOpen() && typeof d.open === 'function') d.open();
      hideAdding(false);
      getCart().then(function (cart) { lastCart = cart; syncBadge(cart); markChildRows(cart); }, function () {});
    });
  }

  function renderSections(sections, ids) {
    return loadThemeModules().then(function () {
      ids.forEach(function (id) {
        if (!sections[id]) return;
        var c = $('cart-items-component[data-section-id="' + id + '"]');
        var inDrawer = !!(c && c.closest('cart-drawer-component'));
        if (sectionRenderer && sectionRenderer.morphSection) {
          sectionRenderer.morphSection(id, sections[id], inDrawer ? 'hydration' : 'full', { injectStylesheet: true });
        }
      });
      syncEmptyClass();
    });
  }

  /** dialog の cart-drawer--empty（中央寄せ）は hydration morph で同期されないので、行の有無に合わせる */
  function syncEmptyClass() {
    var dlg = dialogOf(drawer());
    if (!dlg) return;
    var empty = !drawerRows().length;
    if (dlg.classList.contains('cart-drawer--empty') !== empty) dlg.classList.toggle('cart-drawer--empty', empty);
  }

  function formHasManualAddon(form) {
    try {
      var fd = new FormData(form);
      var v = fd.get('properties[_gpo_addon_products]');
      return !!(v && /"t":"(?!price")/.test(String(v)));
    } catch (e) { return false; }
  }

  document.addEventListener('cart:error', function () { hideAdding(true); });

  // ⑩ product-form-component の外の /cart/add フォームは fetch で送る。
  //    GPO のクローンボタンがあるときは GPO が横取りするので触らない
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (formHasManualAddon(form)) return;
    if (form.closest('product-form-component') || form.querySelector('.gpo-clone-atc-button') || !drawer()) return;
    e.preventDefault();
    takeAddIntent();
    showAdding();
    var fd = new FormData(form);
    fd.append('sections', allSectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    onCartRequestStart();
    origFetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        onCartRequestEnd();
        if (!res.ok) {
          hideAdding(true);
          if (res.json && res.json.description) window.alert(res.json.description);
          return;
        }
        afterAdd(res.json, true);
      })
      .catch(function () { onCartRequestEnd(); hideAdding(true); });
  }, true);

  /* ------------------------------------------------------------------ *
   * ⑥ 商品ページでは、カート変更後の GPOConfigs.initialize() で商品オプションを
   *   作り直させない（テーマの cart-items が変更のたびに呼ぶ。オプション欄が一瞬消える原因）。
   *   2回目以降の呼び出しはカート側の処理だけにする。
   * ------------------------------------------------------------------ */

  function guardGpoReinit() {
    var G = window.GPOConfigs;
    if (!G || typeof G.initialize !== 'function' || G.__a97guarded) return;
    var orig = G.initialize;
    G.__a97guarded = true;
    G.initialize = function () {
      var onProduct = /^\/products\//.test(window.location.pathname);
      var rendered = $('.gpo-container .gpo-element');   // 初回の initialize より前は存在しない
      if (onProduct && rendered && typeof G.loadCartScripts === 'function') {
        try { return G.loadCartScripts(); } catch (e) { return orig.apply(this, arguments); }
      }
      return orig.apply(this, arguments);
    };
  }

  /* ------------------------------------------------------------------ *
   * 起動
   * ------------------------------------------------------------------ */

  function watchDrawer() {
    var d = drawer();
    if (!d) return;

    // 利用者が自分で閉じた操作の記録（閉じるボタン・オーバーレイ・Esc・スマホの戻る）
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest('.cart-drawer__close-button') || t === dialogOf(d)) markUserClosed();
    }, true);
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) markUserClosed();
    }, true);
    window.addEventListener('popstate', function () {
      var dlg = dialogOf(d);
      if (dlg && dlg.open) markUserClosed();
    });

    // ドロワーの中身が差し替わったら子行の印を付け直す。追加中の表示が消されたら差し込み直す
    var marking = false;
    new MutationObserver(function () {
      if (adding) ensureAddingOverlay();
      // morph で消された直後（描画前）に戻す。ちらつき防止
      ensureClearControl();
      if (lastCart && !marking) { marking = true; try { markChildRows(lastCart); } finally { marking = false; } }
    }).observe(d, { childList: true, subtree: true });

    // 開いた時点で一度照合（別タブでの変更・GPO の裏処理の取りこぼし）
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t instanceof HTMLDialogElement && t.open) {
          scheduleReconcile(0);
          break;
        }
      }
    }).observe(d, { attributes: true, attributeFilter: ['open'], subtree: true });
  }

  function start() {
    injectStyle();
    tidyPropertyLabels();
    watchDrawer();
    guardGpoReinit();
    installGpoReconcileGuard();
    ensureGpoMessages();
    // GPO の埋め込みがこのスクリプトより後に GPOConfigs を作る場合に備える
    if (!window.GPOConfigs || !window.GPOConfigs.__a97guarded) {
      var tries = 0;
      var iv = setInterval(function () {
        guardGpoReinit();
        installGpoReconcileGuard();
        ensureGpoMessages();
        if ((window.GPOConfigs && window.GPOConfigs.__a97guarded) || ++tries > 40) clearInterval(iv);
      }, 250);
    }
    // カートページは行が最初から見えているので、子行の印付けのために一度だけ照合する
    if (/^\/cart(\/|$)/.test(window.location.pathname) && $('cart-items-component')) scheduleReconcile(300);
    // それ以外の通常の読み込みでは /cart.js を叩かない。子行の印はドロワーが開いた時点の照合で付く。
    // 直前に変更中の印が残っていれば（GPO の reload 直後）一度だけ照合し、開いていたドロワーを戻す。
    var pending = readPending();
    if (pending) {
      clearPending();
      wasOpen = !!pending.open;
      userClosed = false;
      scheduleReconcile(400);
      // カートの反映が遅れることがある（この店は cart の DC が遠い）ので、少し置いてもう一度
      setTimeout(function () { scheduleReconcile(0); }, 2500);
    }
  }

  /** 外部（points-fix.js）からディスカウントコードを付け外しする口。セクション再描画まで面倒を見る */
  window.A97Cart = window.A97Cart || {};
  window.A97Cart.setDiscount = function (code) {
    var ids = allSectionIds();
    suppressGpoReconcile();
    return postCart('/cart/update.js', {
      discount: code || '',
      sections: ids.join(','),
      sections_url: window.location.pathname
    }).then(function (cart) {
      return renderFromCart(cart, ids).then(function () { return cart; });
    });
  };
  /** 何も変えずにセクションだけ描き直す。カートの反映が遅れたときの追いつき用 */
  window.A97Cart.rerender = function () {
    var ids = allSectionIds();
    return postCart('/cart/update.js', {
      updates: {}, sections: ids.join(','), sections_url: window.location.pathname
    }).then(function (cart) {
      return renderFromCart(cart, ids).then(function () { return cart; });
    });
  };
  window.A97Cart.lock = lockCart;
  window.A97Cart.unlock = unlockCart;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();